<div class="max-ww-6rem">
    <div *ngIf="!loading">
        <p-chart type="bar" [data]="data" [options]="options" height="50"></p-chart>
    </div>
</div>
